import { getToken } from 'firebase/app-check';
import { appCheck } from '../../firebase';

export function useLoginUser() {
    
    const loginUser = async (userData: { email: string; password: string }): Promise<{ success: boolean; message: string, token: string, user?: any }> => {
    const { token } = await getToken(appCheck);
      try {
  
        const res = await fetch('/login', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'X-Firebase-Appcheck': token,
          },
          body: JSON.stringify(userData),
          
        })
  
        if (!res.ok) throw new Error(await res.text())
  
        const responseData = await res.json();
        return { success: res.ok, message: responseData.message || 'Login successful.', user: responseData.user, token: responseData.token }
  
      } catch (err) {
        console.error('Error creating user', err)
        return { success: false, message: 'Login failed due to an error.', token: '' }
      }
  
    }

    const forgotPasswordUser = async (userData: { email: string; }): Promise<{ success: boolean; message: string, }> => {
      const { token } = await getToken(appCheck);
        try {
    
          const res = await fetch('/forgotPassword', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'X-Firebase-Appcheck': token,
            },
            body: JSON.stringify(userData),
          })
    
          if (!res.ok) throw new Error(await res.text())
    
          const responseData = await res.json()
          return { success: res.ok, message: responseData.message || 'Login successful.'}
    
        } catch (err) {
          console.error('Error creating user', err);
          return { success: false, message: 'Login failed due to an error.'}
        }
    
    }

    const validateResetToken = async (resetToken: string): Promise<{ success: boolean; message: string }> => {
        const userData = { token: resetToken };
        const { token } = await getToken(appCheck);
        try {
            const res = await fetch(`/validateResetToken`, {
                method: 'POST',
                headers: { 
                  'Content-Type': 'application/json',
                  'X-Firebase-Appcheck': token,
                },
                body: JSON.stringify(userData),
            });

            if (!res.ok) throw new Error(await res.text());

            const responseData = await res.json();
            return { success: responseData.success, message: responseData.message || 'Token validation successful.' };
        } catch (err) {
            console.error('Error validating reset token', err);
            return { success: false, message: 'Token validation failed due to an error.' };
        }
    }

    const resetUserPassword = async (resetToken: string, password: string): Promise<{ success: boolean; message: string }> => {
        const userData = { token: resetToken, password };
        const { token } = await getToken(appCheck);
        try {
            const res = await fetch(`/resetUserPassword`, {
                method: 'POST',
                headers: { 
                  'Content-Type': 'application/json',
                  'X-Firebase-Appcheck': token,
                },
                body: JSON.stringify(userData),
            });

            if (!res.ok) throw new Error(await res.text());

            const responseData = await res.json();
            return { success: responseData.success, message: responseData.message || 'Token validation successful.' };
        } catch (err) {
            console.error('Error validating reset token', err);
            return { success: false, message: 'Token validation failed due to an error.' };
        }
    }


    
  
    return { loginUser, forgotPasswordUser, validateResetToken, resetUserPassword }
    
}

